import Cookies from "shared/util/Cookies";

// -----------------------------------------------------------------------------------

function secondsFromNow (sec) {
	const res = new Date();
	res.setTime(new Date().getTime() + sec * 1000);
	return res;
}

// -----------------------------------------------------------------------------------

// bind cookies functionality for use in this file (and they get bound to the window
// at the bottom)
const setCookie = Cookies.setCookie;
const deleteCookie = Cookies.deleteCookie;
const getCookie = Cookies.getCookie;

// nano cookie is a serialized array, where each item in the array is an obj with:
//   k: (the key)
//   v: (the value)
//   e: (expiration GMT milliseconds)

export const NanoCookie = {

	// expires must be present. it's an obj and should have one of:
	//     "ms" - milliseconds till you want it to expire;				NanoCookie.set("foo","bar",{ms:3600*1000});
	//     "gmt" - gmt in milliseconds (JS standard);					NanoCookie.set("foo","bar",{gmt:242838923498042343982});
	//     "date" - a Date object with expiration;						NanoCookie.set("foo","bar",{new Date("January 1, 2008")});
	set: function(key, value, expires) {
		const cookies = this.deserialize();
		const d = new Date();
		const obj = new Object();
		obj.k = key;
		obj.v = value;
		if (expires.ms)
		{ obj.e = d.getTime() + parseInt(expires.ms); }
		else if (expires.gmt)
		{ obj.e = expires.gmt; }
		else
		{ obj.e = expires.date.getTime(); }
		if (isNaN(obj.e))
		{ obj.e = 0; }
		let found = false;

		for (let i = 0; i < cookies.length; i++) {
			if (cookies[i].k == key) {
				cookies[i] = obj;
				found = true;
			}
		}
		if (! found)
		{ cookies.push(obj); }
		this.serializeAndStore(cookies);
	},
	get: function(key) {
		const cookies = this.deserialize();
		for (let i = 0; i < cookies.length; i++) {
			if (cookies[i].k == key) {
				return cookies[i].v;
			}
		}
		return null;
	},

	// Returns an array of the form for all nanocookies:
	//
	// [ {key : "foo", value: "bar", expires : <date obj>}, {key : "foo2", value: "bar2", expires : <date obj>}, ....]
	//
	// nano_cookie_str is optional and passed to deserialize.
	// otherwise it'll get the cookie str from the cookie called "nano"
	//
	getAll: function(nano_cookie_str) {
		const cookies = this.deserialize(nano_cookie_str);
		const res = [];
		for (let i = 0; i < cookies.length; i++) {
			const obj = new Object();
			obj.key = cookies[i].k;
			obj.value = cookies[i].v;
			obj.expires = new Date(cookies[i].e);
			res.push(obj);
		}
		return res;
	},

	// Returns an array of the form:
	//
	// [ {key : "foo", value: "bar", expires : <date obj>}, {key : "foo2", value: "bar2", expires : <date obj>}, ....]
	//
	// containing all the cookies that have a key matching a given regexp.
	//

	findRegExp: function(regexp) {
		const cookies = this.deserialize();
		const res = [];
		for (let i = 0; i < cookies.length; i++) {
			if (regexp.test(cookies[i].k)) {
				const obj = new Object();
				obj.key = cookies[i].k;
				obj.value = cookies[i].v;
				obj.expires = new Date(cookies[i].e);
				res.push(obj);
			}
		}
		return res;
	},
	remove: function(key) {
		this.set(key, "", { ms: -1 }, true);
	},
	removeAll: function() {
		deleteCookie("nano");
	},

	// gets from cookie called "nano" ; alternatively you
	// can pass it your own cookie and it'll deserialize that
	deserialize: function(nano_cookie_str) {
		const x = nano_cookie_str || getCookie("nano");

		const result = [];
		if (! x)
		{ return result; }
		else {
			const individuals = x.split("|");
			for (let i = 0; i < individuals.length; i++) {
				const obj = new Object();
				const pairs = individuals[i].split(",");
				for (let j = 0; j < pairs.length; j++) {
					const pair = pairs[j].split("=");
					let val = unescape(pair[1]);
					const pval = parseInt(val);
					if (pval == val && ! isNaN(pval))
					{ val = pval; }
					obj[pair[0]] = val;
				}
				result.push(obj);
			}
			result.sort(this.compareDates);

			// Strip anything expired
			const d = new Date();
			while (result.length > 0 && new Date(result[result.length - 1].e) < d) {
				result.length--;
			}
			return result;
		}
	},

	// We end up with a string with "|" separating each cookie,
	// and k,v,e, are separated by ":"
	// k=foo,e=3298498329,v=hi%20there|k:foo2:e:3298498329:v:hi%20there2|k:foo:e:3298498329:vhi%20there
	serializeAndStore: function(cookies) {
		let res = "";
		for (let i = 0; i < cookies.length; i++) {
			res += (i == 0) ? "" : "|";
			res += `k=${escape(cookies[i].k)}`;
			res += `,e=${escape(cookies[i].e)}`;
			res += `,v=${escape(cookies[i].v)}`;
		}
		setCookie("nano", res, secondsFromNow(3600 * 24 * 365));
	},
	compareDates: function(a, b) {
		if (a.e && b.e)
		{ return ((a.e < b.e) ? 1 : ((a.e > b.e) ? -1 : 0)); }
	},
};

window.secondsFromNow = secondsFromNow;
window.setCookie = setCookie;
window.getCookie = getCookie;
window.deleteCookie = deleteCookie;
window.NanoCookie = NanoCookie;



// WEBPACK FOOTER //
// ./src/legacy/Cookies.js